import { render } from "./SupportMenu.vue?vue&type=template&id=2794d926"
import script from "./SupportMenu.vue?vue&type=script&lang=js"
export * from "./SupportMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__